import Button from './form-fields/Button';
import Checkbox from './form-fields/Checkbox';
import Default from './form-fields/Default';
import FormComponent from './FormComponent';
import Number from './form-fields/Number';
import Radio from './form-fields/Radio';
import Select from './form-fields/Select';
import Text from './form-fields/Text';
import Textfield from './form-fields/Textfield';

export {
  Button,
  Checkbox,
  Default,
  FormComponent,
  Number,
  Radio,
  Select,
  Text,
  Textfield
};

export const formFields = [
  Button,
  Checkbox,
  Default,
  Number,
  Radio,
  Select,
  Text,
  Textfield
];